import {
  buildPageViewAttributes,
  fetchRoktRuntimeConfig,
  getRoktConfig,
  getRoktConsent,
  hasRealRoktApiKey,
  initRokt,
  logPageView,
  setRoktJurisdiction,
} from '@eventbrite/rokt-sdk';
import { Stage } from '@eventbrite/webapp-constants';
import { useEffect, useState } from 'react';

let sdkInited = false;

export function resetRoktInitForTests() {
  if (process.env.NODE_ENV === 'test') {
    sdkInited = false;
  }
}

export function RoktInit({ stage }: { stage: Stage }) {
  const [apiKey, setApiKey] = useState<string>();
  const [jurisdiction, setJurisdiction] = useState<'EU' | 'ROW'>();

  useEffect(() => {
    let stale = false;
    void fetchRoktRuntimeConfig('/organizer-profile/api/rokt/')
      .then((config) => {
        if (stale) return;
        if (config.jurisdiction !== 'EU' && config.jurisdiction !== 'ROW') {
          setRoktJurisdiction('EU');
          setJurisdiction('EU');
          setApiKey(undefined);
          return;
        }
        setRoktJurisdiction(config.jurisdiction);
        setJurisdiction(config.jurisdiction);
        setApiKey(config.apiKey);
      })
      .catch(() => {
        if (stale) return;
        setRoktJurisdiction('EU');
        setJurisdiction('EU');
        setApiKey(undefined);
      });
    return () => {
      stale = true;
    };
  }, []);

  useEffect(() => {
    if (
      !apiKey ||
      !jurisdiction ||
      sdkInited ||
      !hasRealRoktApiKey(getRoktConfig(stage === Stage.PROD, apiKey))
    ) {
      return;
    }

    const consent = getRoktConsent();
    sdkInited = true;
    try {
      initRokt(getRoktConfig(stage === Stage.PROD, apiKey), {
        noFunctional: consent.noFunctional,
        noTargeting: consent.noTargeting,
        onLoad: () => {
          const pageName = 'organizer_profile';
          logPageView(
            pageName,
            buildPageViewAttributes({ pageName, path: window.location.pathname }),
          );
        },
      });
    } catch {
      sdkInited = false;
    }
  }, [apiKey, jurisdiction, stage]);

  return null;
}
